import React from 'react'

interface ChatLiveMomentIconProps {
  size?: number
  color?: string
}

export const ChatLiveMomentIcon: React.FC<ChatLiveMomentIconProps> = ({
  size = 32,
  color = '#FFFFFF',
}) => {
  return (
    <div style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
        <path
          d="M10.5 27.0002H18.7941C21.2794 27.0002 23.2941 24.9855 23.2941 22.5002V17.5133V14.2061C23.2941 11.7208 21.2794 9.70605 18.7941 9.70605H14.6471H10.5C8.01472 9.70605 6 11.7208 6 14.2061V22.5002C6 24.9855 8.01472 27.0002 10.5 27.0002Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M23.2943 23.2941V23.2941C25.341 23.2941 27.0002 21.6349 27.0002 19.5882V13.8073V10.5C27.0002 8.01472 24.9855 6 22.5002 6H18.3531H13.4119C11.3652 6 9.70605 7.65918 9.70605 9.70588V9.70588"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M13.7613 20.0056C16.6856 17.3637 19.8224 17.4338 22.9729 20.1847L23.1024 20.2992L22.9729 21.3557C19.7 18.6189 17.0207 18.4878 14.4833 20.7799C13.0434 22.1656 11.6487 22.8765 10.2934 22.8765C8.97988 22.8765 7.33822 22.0802 6 20.7799V20.2992L6.40463 19.7224C7.60848 20.9304 9.25495 21.8177 10.2934 21.8177C11.3352 21.8177 12.4891 21.2295 13.7613 20.0056Z"
          fill={color}
          stroke={color}
          strokeWidth="0.2"
        />
        <circle
          cx="11.5116"
          cy="15.2811"
          r="1.87059"
          stroke={color}
          strokeWidth="1.2"
        />
      </svg>
    </div>
  )
}

export default ChatLiveMomentIcon
